<template>
	<div class="pd-l10">
		<div class="bg-white f12 h30 lh30 pd-l10 crumb">
      <div class="fl" v-for="(item, index) in crumbList">
        <router-link class="fl mouse-pointer crumb-item-link"
                     tag="div"
                     :to="{ path: item.path }" v-if="item.type === 'link'">{{ item.name }}</router-link>
        <div class="fl crumb-item-name" v-if="item.type === 'text'">{{ item.name }}</div>
        <div class="fl mg-lr5" v-if="(index + 1) < crumbList.length">/</div>
      </div>
    </div>
  </div>
  
	
</template>

<script>
	export default {
		name: "crumb",
    props: ['pageName', 'crumbList'],
    
    created() {
		  let viewHistoryJson = window.localStorage.getItem('viewHistory');
		  let viewHistory = !this.isInvalid(viewHistoryJson) ? JSON.parse(viewHistoryJson) : {};
		  let list = !this.isInvalid(viewHistory.list) ? viewHistory.list : [];
		  let idx = !this.isInvalid(viewHistory.index) ? viewHistory.index : [];
		  
		  if (list.length === 0) {
        list.push({ name: '首页', routerName: 'home' })
      }
		  
		  this.$store.commit('updateViewHistory', { idx: idx, list: list });
  
      this.$store.commit('changeViewHistory', idx);
    },
    
    data() {
		  return {
		    isLoading: false,
			  
			  isShow: true,
			  isShowIndex: null,
      }
    },
    
    methods: {
      goToPage(idx, name) {
        this.$store.commit('changeViewHistory', idx);
        
        if (this.$route.name !== name) {
          this.$router.push({
            name: name
          })
        }
      },
  
      // 刷新页面
      refreshPage() {
        this.isLoading = true;
        this.$router.go(0);
      },
	    
	    // 设置当前页签高亮
	    setActive() {
		    let list = this.$store.state.viewHistory.list;
		    let len = list.length;

		    for (let i = 0; i < len; i ++) {
			    if (list[i].routerName === this.$route.name) {
				    this.$store.commit('changeViewHistory', i);
				    break
			    }
		    }
	    },
      
      // 关闭当前页签
      closeThisHistory(idx) {
      	
	      this.$store.commit('deleteViewHistory', idx);

	      let list = this.$store.state.viewHistory.list;
	      let len = list.length;

	      idx > len - 1 ? idx -- : '';
	      
	      if (list[idx].routerName !== this.$route.name) {
		      this.$router.push({
			      name: list[idx].routerName
		      })
	      }

	      for (let i = 0; i < len; i ++) {
		      if (list[i].routerName === this.$route.name) {
			      this.$store.commit('changeViewHistory', i);
			      break
		      }
	      }
      },
	    
	    // 打开右键菜单
	    openRightMouseMenu(idx) {
      	this.$store.commit('changeHistoryRightMouseMenuStatus', { idx: idx, show: true })
	    },
	    
	    // 关闭左侧
	    closeLeftItems(index) {
        let arr = [];
        let isPush = false;
        this.$store.state.viewHistory.list.forEach((obj, idx) => {
          if (obj.routerName === 'home' || idx >= index) {
            arr.push(obj);
          }
  
          if (idx <= index && obj.routerName === this.$route.name) {
            isPush = true
          }
        });
    
        this.$store.commit('updateViewHistory', { idx: null, list: arr });
        window.localStorage.setItem('viewHistory', JSON.stringify(this.$store.state.viewHistory));
        this.$store.commit('changeHistoryRightMouseMenuStatus', { idx: null, show: false });
        
        if (isPush && arr[1].routerName !== this.$route.name) {
          this.$router.push({
            name: arr[1].routerName
          })
        }
    
        this.setActive();
	    },
	    
	    // 关闭右侧
	    closeRightItems(index) {
        let arr = [];
        let isPush = false;
        this.$store.state.viewHistory.list.forEach((obj, idx) => {
          if (obj.routerName === 'home' || idx <= index) {
            arr.push(obj);
          }
  
          if (idx >= index && obj.routerName === this.$route.name) {
            isPush = true
          }
          
        });
        
        this.$store.commit('updateViewHistory', { idx: null, list: arr });
        window.localStorage.setItem('viewHistory', JSON.stringify(this.$store.state.viewHistory));
    
        this.$store.commit('changeHistoryRightMouseMenuStatus', { idx: null, show: false });
        
        if (isPush && arr[arr.length - 1].routerName !== this.$route.name) {
          this.$router.push({
            name: arr[arr.length - 1].routerName
          })
        }
        
        this.setActive();
	    },
	    
	    // 关闭其它
	    closeOthers(index) {
      	let arr = [];
      	
      	this.$store.state.viewHistory.list.forEach((obj, idx) => {
      		if (idx === 0 || index === idx) {
			      arr.push(obj);
		      }
	      });
      	
		    this.$store.commit('updateViewHistory', { idx: 1, list: arr });
		    this.$store.commit('changeViewHistory', 1);
        window.localStorage.setItem('viewHistory', JSON.stringify(this.$store.state.viewHistory));
        this.$store.commit('changeHistoryRightMouseMenuStatus', { idx: null, show: false });
		    
		    // 如果不在当前页则跳转至当前页
		    if (arr[1].routerName !== this.$route.name) {
			    this.$router.push({
				    name: arr[1].routerName
			    })
		    }
      
	    }
	    
	    // 刷新页面
    },
    
    watch: {
		  $route(to, from) {
        let obj = {
          name: to.meta.crumbList[to.meta.crumbList.length - 1].name,
          routerName: to.name,
        };
		    this.$store.commit('addViewHistory', obj);
			  
		    let list = this.$store.state.viewHistory.list;
		    let len = list.length;
		    
		    for (let i = 0; i < len; i ++) {
		    	if (list[i].routerName === obj.routerName) {
				    this.$store.commit('changeViewHistory', i);
				    break
			    }
		    }
      }
    }
	}
</script>

<style>
  
  .view-history-list .el-icon-refresh.is-loading {
    animation: animation-refresh 1s linear infinite;
  }

@-webkit-keyframes animation-refresh {
  from {
   -webkit-transform: rotate(0deg);
  }
  to {
   -webkit-transform: rotate(360deg);
  }
}

@keyframes animation-refresh {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
